export default __webpack_public_path__ + "static/media/cool_1.4a285571.jpg";